import React, { useContext, useCallback, useState, useEffect } from 'react'
import { StateContext } from 'store/contexts'
import {
  Flex,
  // Heading,
  Button,
  // ProductsFeed,
  ShareBox,
  HandDownloader,
  CardDownloader,
  ResultCards,
  LineBreak,
} from 'components'
import { trackSubscription, useScreenTrack } from 'api/tracking'
import { GoodForOneOrgasmCard } from 'components'

const RESULT_CARD_PROPS = {
  margin: 2,
  flex: '0 0 auto',
  className: 'result-card',
  boxShadow: '1px 1px 6px 0px rgba(54,55,56,0.28)',
}

const DigestScreen = () => {
  const state = useContext(StateContext)
  const hand = state.result.hand
  // const products = state.products
  const contentConfig = state.ui.contentConfig.digest
  const [subscriptionBox, setSubBox] = useState<HTMLElement | null>(null)
  const [subscribed, setSubscribed] = useState(false)
  const [cardImgs, setCardImgs] = useState<string[]>([])
  const [selectedCardIndex, setSelectedCardIndex] = useState<number>(-1)

  useScreenTrack('results')

  useEffect(() => {
    // Create a small delay so it looks better when the join club button is rendered almost instantly.
    setTimeout(() => {
      setSubBox(document.getElementById('oof-subscription-box'))
    }, 500)
  }, [])

  // Custom toggling of the SubscriptionBox hidden in the DOM for the SendGrid Subs.
  const toggleSubscriptionBox = (show: boolean) => {
    const dripWidget = subscriptionBox?.querySelector(
      'form[data-drip-embedded-form]'
    )
    const dripSubmitBtn = subscriptionBox?.querySelector('.drip-submit-btn')
    const dripInput = subscriptionBox?.querySelector('.drip-input')

    if (show) {
      const headerOffsetHeight =
        document.querySelector('header')?.offsetHeight ?? 0

      // Position the box so it looks like it's apart of the SubscriptionModal..
      subscriptionBox!.style.display = 'block'
      subscriptionBox!.style.top = `calc(0px + ${headerOffsetHeight}px)`

      // Listen for changes to detect success and close modal
      dripWidget?.addEventListener(
        'DOMSubtreeModified',
        onDripWidgetDomModified
      )
      // Listen for click to set loader
      dripSubmitBtn?.addEventListener('click', onDripSubmitBtnClick)
      // Listen for input change to clear any errors (important for the loader to work again after error)
      dripInput?.addEventListener('input', onDripInputChange)
    } else {
      subscriptionBox!.style.display = 'none'
      // Remove events on hide
      dripWidget?.removeEventListener(
        'DOMSubtreeModified',
        onDripWidgetDomModified
      )
      dripSubmitBtn?.removeEventListener('click', onDripSubmitBtnClick)
      dripInput?.removeEventListener('input', onDripInputChange)
    }
  }

  const onDripWidgetDomModified = () => {
    if (subscriptionBox?.querySelector('.drip-response.success')) {
      handleSubModalClose(true)
      toggleDripSubmitBtnLoading(false)
      trackSubscription()
    } else if (subscriptionBox?.querySelector('.drip-response.error')) {
      toggleDripSubmitBtnLoading(false)
    }
  }

  const onDripSubmitBtnClick = () => {
    const dripInputValue = (
      subscriptionBox?.querySelector('.drip-input') as HTMLInputElement
    ).value
    if (dripInputValue !== '') {
      toggleDripSubmitBtnLoading(true)
    }
  }

  const onDripInputChange = () => {
    const response = subscriptionBox?.querySelector('.drip-response')
    if (response) {
      response.classList.remove('error')
      response.innerHTML = ''
    }
  }

  const toggleDripSubmitBtnLoading = (toggle: boolean) => {
    subscriptionBox
      ?.querySelector('.drip-submit-btn')
      ?.classList[toggle ? 'add' : 'remove']('loading')
  }

  const handleSubModalClose = (answer: boolean) => {
    setSubscribed(answer)
    toggleSubscriptionBox(false)
  }

  const handleCardsLoaded = useCallback((imgs: string[]) => {
    setCardImgs(imgs)
  }, [])

  const handleCardSelected = useCallback((index: number) => {
    setSelectedCardIndex(index)
  }, [])

  return (
    <Flex
      height='100%'
      width={1}
      flexDirection='column'
      padding={[0, '16px 0', '16px 0', '16px 0']}
      justifyContent={['space-between', 'center']}
    >
      <Flex height='100%' flexDirection='column'>
        <ResultCards
          hand={hand}
          onLoaded={handleCardsLoaded}
          selected={selectedCardIndex}
          onSelected={handleCardSelected}
          {...RESULT_CARD_PROPS}
        >
          {(resultCardProps) => (
            <GoodForOneOrgasmCard
              handColor={hand.color}
              animal={hand.animal}
              marginLeft='0'
              title={contentConfig?.orgasmCardTitle}
              subTitle={contentConfig?.orgasmCardSubTitle}
              {...resultCardProps}
            />
          )}
        </ResultCards>
        <Flex flexDirection='column' alignItems='center'>
          <CardDownloader
            imgs={cardImgs}
            selected={selectedCardIndex}
            btnText={contentConfig?.downloadCardBtnText}
          />
          <LineBreak />
          {/* {Boolean(products.length) && (
            <>
              <Heading as='h2' padding={2}>
                {contentConfig?.productsHeader || 'Recommended for You'}
              </Heading>
              <ProductsFeed hand={hand} products={products} />
              <LineBreak />
            </>
          )} */}
          <ShareBox />
          <Flex
            flexDirection={['column', null, 'row']}
            alignItems='center'
            justifyContent='center'
            marginBottom={2}
            width={1}
          >
            <HandDownloader
              imgs={cardImgs}
              btnText={contentConfig?.printHandBtnText}
            />
            {subscriptionBox && !subscribed && (
              <Button
                full
                thin
                maxWidth='290px'
                margin={1}
                marginTop={2}
                onClick={() => {
                  toggleSubscriptionBox(true)
                }}
              >
                {contentConfig?.subscribeBtnText || 'Join the Newsletter'}
              </Button>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DigestScreen
